import { render, staticRenderFns } from "./heat_seal_request.vue?vue&type=template&id=fb502920&scoped=true&"
import script from "./heat_seal_request.vue?vue&type=script&lang=js&"
export * from "./heat_seal_request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb502920",
  null
  
)

export default component.exports